import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Settings } from '../types/settings';

interface SettingsStore extends Settings {
  updateSettings: (settings: Partial<Settings>) => void;
  resetSettings: () => void;
}

const defaultSettings: Settings = {
  theme: 'dark',
  fontFamily: 'serif',
  fontSize: 18,
  lineHeight: 1.8,
  maxWidth: 1000,
  autoSave: true,
  autoSaveInterval: 30000,
  showWordCount: true,
  showToolbar: true,
  backgroundStyle: 'solid',
  backgroundColor: '#1a1a1a',
  backgroundImage: null,
  keyboardShortcuts: true,
  wordGoal: 500,
  showWordGoal: false,
  editorOpacity: 0.08,
  editorBlur: 25,
  useGlassmorphism: true,
  editorHeight: 70,
  textColor: 'white',
};

export const useSettingsStore = create<SettingsStore>()(
  persist(
    (set) => ({
      ...defaultSettings,

      updateSettings: (newSettings) => {
        set((state) => ({ ...state, ...newSettings }));
      },

      resetSettings: () => {
        set(defaultSettings);
      },
    }),
    {
      name: 'focuswriter-settings',
    }
  )
);